import WalletList from "./WalletList";

export default WalletList;
